import { Tooltip as MUITooltip } from '@mui/material'
interface ITooltipProps {
  children: React.ReactElement<any>
  title: string | React.ReactElement<any>
  followCursor?: boolean
  disabled?: boolean
}
export default function Tooltip({ children, title, followCursor = true, disabled = false }: ITooltipProps) {
  if (disabled) {
    return children
  }

  return (
    <MUITooltip title={title} followCursor={followCursor} arrow enterDelay={200} leaveDelay={200}>
      {children}
    </MUITooltip>
  )
}
